// extracted by mini-css-extract-plugin
export default {"buttonPrevIcon":"buttonMediumDefaultPrevIcon_buttonPrevIcon__5R+FY"};